<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div id="alert-modal" class="modal opacity-class" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="modal-header">
                    <slot name="header">
                        <span class="content-header">{{ title }}</span>

                        <button type="button" class="btn-close" @click="close" aria-label="Close modal">x</button>
                    </slot>
                </header>
                <section class="modal-body">
                    <slot name="body">
                        <span v-html="content"></span>
                    </slot>
                </section>
                <footer class="modal-footer">
                    <slot name="footer">
                        <button v-if="continue_btn" type="button" class="btn-alert" @click="continueAction">{{ $t('alert-modal.continue') }}</button>
                        <button type="button" id="close-alert" class="btn-alert" @click="close" aria-label="Close modal">{{ $t('alert-modal.close') }}</button>
                    </slot>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'AlertModal',
        props: {
            title: String,
            content: String,
            continue_action: String,
            continue_btn: Boolean
        },
        data() {
            return {
                lang: ""
            }
        },
        methods: {
            close() {
                this.$emit('close');
            },
            continueAction() {
                this.continue_action();
            }
        }
    }
</script>

<style>
    .modal-fade-enter, .modal-fade-enter-active,
    .modal-fade-leave-active {
        opacity: 0;
    }
    .modal-fade-enter-to, .modal-fade-leave {
        opacity: 1;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .5s ease
    }
    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .modal {
        background: #FFFFFF;
        box-shadow: 2px 2px 20px 1px;
        overflow-x: auto;
        display: flex;
        flex-direction: column;
    }
    .modal-header,
    .modal-footer {
        padding: 15px;
        display: flex;
    }
    .modal-header {
        border-bottom: 1px solid #eeeeee;
        color: #4AAE9B;
        justify-content: space-between;
        align-items: center;
        padding-left: 30px;
        font-size: 1.2rem;
        height: 40px;
    }
    .modal-footer {
        border-top: 1px solid #eeeeee;
        justify-content: flex-end;
    }
    .modal-body {
        position: relative;
        padding: 20px 10px;
        overflow: auto;
    }
    .btn-close {
        border: none;
        font-size: 20px;
        padding: 20px;
        cursor: pointer;
        font-weight: bold;
        color: #4AAE9B;
        background: transparent;
    }
    #alert-modal {
        width: auto;
        height: auto; 
        position: unset;
        max-width: 490px;
    }
    #alert-modal .modal-body {
        padding: 25px;
    }
    span.content-header {
        left: 10px;
    }

    #alert-modal .modal-body span {
        color: #6c757d;
        font-size: 0.9rem;
        text-align: justify;
    }
    .btn-alert {
        white-space: nowrap;
        vertical-align: middle;
        width: 11.8125rem;
        min-height: 2.1875rem;
        font-size: 1rem;
        padding-top: .25rem;
        padding-bottom: .25rem;
        font-weight: 700;
        text-transform: uppercase;
        color: #F0F4F8;
        background-color: #2EB085;
        user-select: none;
        border: 1px solid transparent;
        padding: 0.375rem 0.75rem;
        border-radius: 0.25rem;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .btn-alert:hover, .btn-alert:active { background-color: #207257; }
    .btn-alert:focus {
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgb(46 176 133 / 25%);
    }

    @media screen and (max-width: 500px) {
        #alert-modal {
            width: 85%;
        }
    }
</style>